import { ViewType } from '@/domains/base/enums/view-type';
export const DEFAULT_USER_SETTING = {
    row_height: 'auto',
};
export const DEFAULT_USER_INFO = {
    is_created_space: false,
    view_type_list: [ViewType.TABLE],
};
export const API_VIEW_TYPE_TRANSLATE_MAP = {
    patentFolderPage: ViewType.TABLE,
    patentImagePage: ViewType.STANDARD,
    patentFullimgPage: ViewType.FULL_IMAGE,
    patentThumbPage: ViewType.THUMB,
    patentCategoryPage: ViewType.CATEGORY,
};
export const API_VIEW_TYPE_TRANSLATE_REVERSE_MAP = {
    [ViewType.TABLE]: 'patentFolderPage',
    [ViewType.STANDARD]: 'patentImagePage',
    [ViewType.FULL_IMAGE]: 'patentFullimgPage',
    [ViewType.THUMB]: 'patentThumbPage',
    [ViewType.WORD_CLOUD]: 'patentWordCloudPage',
    [ViewType.FAST_TABLE]: 'patentLitePage',
    [ViewType.CATEGORY]: 'patentCategoryPage',
};
export const VIEW_TYPE_ORDER = [
    ViewType.TABLE,
    ViewType.STANDARD,
    ViewType.FULL_IMAGE,
    ViewType.THUMB,
    ViewType.CATEGORY,
];
